import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction-to-pickbazar"
    }}>{`Introduction to PickBazar`}</h1>
    <p>{`Welcome to the PickBazar documentation! `}</p>
    <p>{`We have presented one of the Fastest Ecommerce App built with React, NextJS, TypeScript, Laravel(GraphQL, REST API) and Tailwind CSS.
Here, we have tried to cover all the available features & topics presented in this application. We are inviting your to go through the whole documentation, so that it may helps you to understand better about what we are offering. `}</p>
    <h2 {...{
      "id": "navigation"
    }}>{`Navigation`}</h2>
    <p>{`You can find different topics in the table of contents. On desktop, you should see it in the left sidebar. On mobile, you should see it after pressing an icon with Hamberger in the top right corner.`}</p>
    <h2 {...{
      "id": "supported-platforms--framework-for-local-development"
    }}>{`Supported Platforms & Framework For Local Development`}</h2>
    <p>{`In your production environment, maintaining similar configuration is recommended. `}</p>
    <ul>
      <li parentName="ul">{`MacOS, Windows, and Linux are supported`}</li>
      <li parentName="ul">{`Compatible Browsers (Firefox, Safari, Chrome, Edge)`}</li>
      <li parentName="ul">{`JavaScript (Node.js 20.0.0 or later, `}<inlineCode parentName="li">{`v20.9.0`}</inlineCode>{` much more appreciable)`}</li>
      <li parentName="ul">{`Laravel 10 environments with PHP 8.1 (at least)`}</li>
    </ul>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`node(20.0.0 or later, `}<inlineCode parentName="li">{`v20.9.0`}</inlineCode>{` much more appreciable)`}</li>
      <li parentName="ul">{`yarn`}</li>
      <li parentName="ul">{`PHP 8.1`}</li>
      <li parentName="ul">{`MySQL 8`}</li>
      <li parentName="ul">{`ext_curl`}</li>
      <li parentName="ul">{`editor: `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{`(recommended)`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Notice : This Pickbazar `}<inlineCode parentName="p">{`v11.0.0`}</inlineCode>{` comes with a major update with some `}<inlineCode parentName="p">{`breaking changes`}</inlineCode>{`. Please keep your current site backup before upgrading to this version.`}</p>
    </blockquote>
    <p><img alt="terms-and-conditions 12" src={require("./images/warning.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      